<template>
  <div v-if="show">
    <section
      class="newsfeed-component"
      resmed-component-name="newsfeed-component"
    >
      <div class="component">
        <div
          class="col-12 text-center headline-text"
          v-if="showCta"
          v-bind:class="`-mode-${[$root.mode]}`"
        >
          <div class="row" v-if="acf.nf_headline" style="margin-bottom: 4px">
            <div class="col-12 heading">
              <div class="row">
                <div class="col-8">
                  <h3
                    style="
                      color: #0D0A15;
                      text-align: left;
                      font-size: 16px;
                      margin-bottom: 4px;
                      line-height: 1.6;
                    "
                    class="heading-xs"
                  >
                    {{ acf.nf_headline }}
                  </h3>
                </div>
                <div class="col-4">
                  <div class="row">
                    <div class="col-12 p-md-0">
                      <span class="dropdown" :class="{ shown: state }"></span>
                      <a
                        href="#"
                        @click.prevent="toggleDropdown"
                        class="dropdown-toggle filterbtn"
                      >
                        <!-- <img
                          src="../../assets/images/filtericon.png"
                          class="filter-image"
                        /> -->

                        <div class="d-flex" style="gap: 4px;">
                          <img
                            src="../../assets/images/filter-icon.svg"
                            class="filter-image"
                          />
                          <span class="text-lg">{{
                            $getTranslation("Filter", $route.params.region)
                          }}</span>
                        </div>
                      </a>
                      <div class="dropdown-menu" v-show="state">
                        <ul class="list-unstyled">
                          <li
                            class="lili"
                            value="all"
                            v-on:click="onClickAll()"
                          >
                            {{ $getTranslation("All", $route.params.region) }}
                          </li>
                          <li
                            class="lili"
                            v-for="(item, index) in productCategories"
                            v-bind:value="item"
                            v-on:click="onClick(item)"
                            v-model="key"
                          >
                            {{
                              $getTranslation(
                                item.toUpperCase(),
                                $route.params.region
                              )
                            }}
                          </li>
                        </ul>
                        <!-- <select
                                 class = "catselect"
                                 @change="onChange($event)"
                                 v-model="key"
                                 style="font-size:12px; background:#fff; border:1px solid"
                                 >
                                   <option v-for="(item, index) in productCategories"
                                        v-bind:value="item"
                                        v-model="key">{{ item.toUpperCase() }}</option>
                                 </select> -->
                      </div>
                      <transition />
                    </div>
                  </div>

                  <!-- <h5 class="filterbtn" :class="{shown: state}">Filter</h5> -->
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              style="overflow: hidden; width: 100% !important"
              class="swiper-wrapper"
            >
              <div class="swiper">
                <div class="row">
                  <div class="col-12" style="padding: 0">
                    <div class="seek">
                      <div
                        ref="swiperContainer"
                        class="swiper-container"
                        v-bind:class="`-mode-${[$root.mode]}`"
                      >
                        <!-- <div
                  v-for="list in feedslist"
                   v-for="list in feedslist"
                   
                  > -->
                        <div
                          class="items swiper-wrapper"
                          v-if="
                            $root.mode === 'lg' ||
                              $root.mode === 'xl' ||
                              $root.mode === 'md'
                          "
                        >
                          <div
                            class="item swiper-slide"
                            v-for="list in feedslist"
                          >
                            <div class="col-12 wrapper" v-for="item in list">
                              <div class="row">
                                <div class="col-12" style="padding: 0px">
                                  <div class="col-12 feedcard">
                                    <!-- <div class="row">
                                <div class="col-12"> -->
                                    <div class="row">
                                      <div
                                        class="col-2"
                                        style="
                                          padding-right: 8px;
                                          padding-left: 8px;
                                        "
                                      >
                                        <img
                                          v-bind:src="item.nf_thumbnail"
                                          class="nficon"
                                        />
                                        <img
                                          v-show="
                                            addNewBadge(item.nf_date) == 'New'
                                          "
                                          src="../../assets/images/new_badge.png"
                                          class="nf-badge"
                                        />
                                      </div>
                                      <div class="col-10">
                                        <a
                                          v-bind:href="item.nf_cta"
                                          v-on:click="
                                            onClickNewsfeed(item.nf_cta)
                                          "
                                          target="_blank"
                                          class="nf-title custom-line-limit"
                                        >
                                          {{ item.nf_title }}
                                        </a>
                                        <h6 class="secondarydata mb-1">
                                          <span class="dateposted">
                                            {{ format_date(item.nf_date) }}
                                          </span>

                                          <span
                                            class="contenttype"
                                            :style="{
                                              background: item.nf_badge_color,
                                            }"
                                          >
                                            {{
                                              $getTranslation(
                                                item.nf_type,
                                                $route.params.region
                                              )
                                            }}
                                          </span>
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- </div>
                            </div> -->
                            </div>
                          </div>
                          <!-- // end of for loop //// -->
                        </div>
                        <!-- </div> -->
                        <!-- /// ------------- mobile view --------------- /// -->
                        <div
                          class="items swiper-wrapper"
                          v-if="$root.mode === 'xs' || $root.mode === 'sm'"
                        >
                          <div
                            class="item swiper-slide"
                            v-for="list in feedslistMobile"
                            style="width:100% !important"
                          >
                            <div class="col-12 wrapper" v-for="item in list">
                              <div class="row">
                                <div class="col-12" style="padding:0px">
                                  <div class="col-12 feedcard">
                                    <!-- <div class="row">
                                <div class="col-12"> -->
                                    <div class="row">
                                      <div class="col-2">
                                        <img
                                          v-bind:src="item.nf_thumbnail"
                                          class="nficon"
                                        />
                                        <img
                                          v-show="
                                            addNewBadge(item.nf_date) == 'New'
                                          "
                                          src="../../assets/images/new_badge.png"
                                          style="width: 80%; margin-top: 6px"
                                        />
                                      </div>
                                      <div class="col-10">
                                        <a
                                          v-bind:href="item.nf_cta"
                                          target="_blank"
                                          style="
                                            font-size: 12px;
                                            color: #000;
                                          "
                                        >
                                          {{ item.nf_title }}
                                        </a>
                                        <h6 class="secondarydata mb-1">
                                          <span
                                            class="dateposted"
                                            style="
                                              font-size: 8px;
                                              color: #4b4b4b;
                                            "
                                          >
                                            {{ format_date(item.nf_date) }}
                                          </span>

                                          <span
                                            class="contenttype"
                                            style="
                                              font-size: 8px;
                                            "
                                            :style="{
                                              background: item.nf_badge_color,
                                            }"
                                          >
                                            {{ item.nf_type }}
                                          </span>
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- </div>
                            </div> -->
                            </div>
                          </div>
                        </div>
                        <!-- /// -------------------- mobile view end ------------------ ///  -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-if="
                  $root.mode === 'lg' ||
                    $root.mode === 'xl' ||
                    $root.mode === 'md'
                "
                v-show="feedslist.length > 1"
              >
                <div class="col">
                  <div ref="swiperPagination" class="swiper-pagination"></div>
                </div>
              </div>
              <div
                class="row"
                v-if="$root.mode === 'xs' || $root.mode === 'sm'"
                v-show="feedslistMobile.length > 1"
              >
                <div class="col">
                  <div ref="swiperPagination" class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- //container end -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import helper from "../../mixins/swiper-helper";
import scrollTarget from "../../mixins/scroll-target";
import uniq from "lodash/uniq";
import _ from "lodash";
import moment from "moment";

export default {
  name: "newsfeed-component", // newsfeed-component
  props: ["acf"],
  data() {
    return {
      slider: undefined,
      nf_items: this.acf.nf_items,
      items_length: this.acf.nf_items.length,
      key: "",
      flllength: 2,
      // show: $cookies.get("b2bFirstName"),
      showCta: this.acf.nf_enable_cta,
      state: false,
    };
  },
  mixins: [helper, scrollTarget],
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        breakpoints: {
          768: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          992: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
        },
        // loop: true,
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
    //  onChange(event) {
    //   console.log(event.target.value);
    // },
    onClick(item) {
      this.key = item;
      this.state = false;
      var elem = this.$el.querySelector('span[aria-label="Go to slide 1"]');
      elem.click();
    },

    onClickAll() {
      this.key = "";
      this.state = false;
      var elem = this.$el.querySelector('span[aria-label="Go to slide 1"]');
      elem.click();
    },
    onClickNewsfeed(doc) {
      let oktaEndpoint = $cookies.get("rocServ");
      let oktaEmail = $cookies.get("rocEmail");
      let oktaSid = $cookies.get("rocSid");
      let oktaRegion = $cookies.get("RegionCode");
      console.log("test", doc);
      if (doc.includes("/secure")) {
        axios({
          url: `${process.env.VUE_APP_ROC_ENPOINT}/graphql`,
          method: "post",
          headers: {
            "Content-Type": "application/json",
            x_api_key: "121",
            session: oktaSid,
          },
          data: {
            query: `mutation CreateDownloadMaterials($input: [DownloadMaterialInput!]!) {
            createDownloadMaterials(input: $input) {
              id
            }
          }`,
            variables: {
              input: [
                {
                  email: oktaEmail,
                  materialPath: doc,
                  materialType: doc.slice(-3),
                  userId: this.$store.state.userId,
                  country: this.$store.state.country,
                },
              ],
            },
          },
        })
          .then(() => {
            window.open(doc, "_blank").focus();
          })
          .catch(() => {
            // this.removeAllCookies();
            window.location.reload();
          });
      }
    },
    addNewBadge(value) {
      const udate = moment(value);
      const current = moment();

      if (current.diff(udate, "days") <= 21) {
        return "New";
      } else {
        return "";
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("MMM DD, YYYY");
      }
    },
    toggleDropdown(e) {
      this.state = !this.state;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.state = false;
      }
    },
  },
  mounted() {
    this.$nextTick(() => this.swhReload());
    document.addEventListener("click", this.close);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  },

  computed: {
    show() {
      const role = $cookies.get("role");
      const categoryCookie = $cookies.get("categories");

      try {
        if (
          (categoryCookie == "" || categoryCookie == null) &&
          (role != "" || role != null)
        ) {
          this.$cookies.set(
            "categories",
            role && role.replace(/approved/g, "approve"),
            null,
            "/",
            window.location.hostname.includes(".resmed.com")
              ? ".resmed.com"
              : "localhost"
          );
        }
      } catch (error) {
        console.log(error);
      }

      const b2bFirstName = $cookies.get("b2bFirstName");

      if (role && role.includes("technical_approved") && b2bFirstName) {
        return true;
      }
      return false;
    },

    productCategories() {
      const list = this.acf.nf_items.map(({ nf_type }) => nf_type);
      return uniq(list);
    },

    filteredList() {
      return this.acf.nf_items.filter((item) => {
        return item.nf_type.includes(this.key);
      });
    },

    getLengthoffilteredlist() {
      const filteredlistlength = this.acf.nf_items.filter((item) => {
        return item.nf_type.includes(this.key);
      });
      const flllength = filteredlistlength.length;
      return filteredlistlength.length;
    },

    feedslist() {
      const feedarr = [];
      let filllist = this.filteredList;
      while (filllist.length > 10) {
        feedarr.push(filllist.slice(0, 10));
        filllist.splice(0, 10);
      }
      if (filllist.length > 0) {
        feedarr.push(filllist);
      }
      return feedarr;
    },

    feedslistMobile() {
      const feedarrmobile = [];
      let filllistM = this.filteredList;
      while (filllistM.length > 5) {
        feedarrmobile.push(filllistM.slice(0, 5));
        filllistM.splice(0, 5);
      }
      if (filllistM.length > 0) {
        feedarrmobile.push(filllistM);
      }
      return feedarrmobile;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.nf-headline {
  font-size: 16px;
  color: #0D0A15;
  text-align: left;
  margin-bottom: 0px;
  font-weight: bold;

  @media only screen and (max-width: 992px) and (min-width: 768px) {
    font-size: 10px;
  }
}

.nf-title {
  font-size: 12px;
  color: #000;
  display: flex;
  align-items: center;
  word-break: break-word;
  font-weight: 600;

  @media (max-width: 992px) and (min-width: 768px) {
    font-size: 10px;
  }
}

.newsfeed-component {
  // padding: 1rem;
  background: #f7eded;
  margin: 15px 0px;
  border-radius: 10px;
  @media (max-width: 992px) {
    padding: 2px;
  }
  @media (max-width: 767px) {
    padding: 12px;
  }
}

.filter-image {
  // width: 52%;
  width: 14px;
  display: initial !important;
}
.feedcard {
  // border: 1px solid #faf6f6;
  // padding: 0.5rem;
  text-align: left !important;
}
.nficon {
  width: 50%;

  @media (min-width: 768px) {
    width: 79%;
    margin-top: 4px;
  }
  @media (max-width: 992px) {
    width: 20px;
    margin-top: 4px;
  }
}
.nf-badge {
  width: 92%;
  margin: 4px 0 10px;
  @media (max-width: 992px) {
    width: 20px;
  }
}

h2 {
  position: relative;
  margin-bottom: 0.5rem;

  @extend %eyebrow-center;
}

h4 {
  position: relative;
  margin-bottom: 0.625rem;

  // @extend %eyebrow-left;
}

p {
  margin: 0 auto 1.5rem auto;
}

.swiper {
  padding: 10px;

  @media (min-width: 768px) {
    padding: 10px !important;
    padding-left: 10px;
    padding-right: 10px;
  }
}

.seek-wrapper {
  position: absolute;
  z-index: 1;

  width: 100%;
  bottom: -42px;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: 992px) {
    width: 20%;
  }

  @media (min-width: 768px) and (max-width: 991px) {
    width: 100%;
    bottom: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  @media (min-width: 1306px) {
    width: 100%;
    bottom: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  a:nth-child(1) {
    float: left;
    transform: translateX(-3rem) scale(1.175);

    @media (min-width: 992px) {
      transform: translateX(-4rem) scale(1.4);
    }
  }

  a:nth-child(2) {
    float: right;
    transform: translateX(3rem) scale(1.175);

    @media (min-width: 992px) {
      transform: translateX(4rem) scale(1.4);
    }
  }
}

.-mode-xs,
.-mode-sm {
  &.swiper-container {
    overflow: visible;
  }
}

.-mode-md,
.-mode-lg,
.-mode-xl {
  &.swiper-container {
    overflow: hidden;
  }
}

.swiper-container {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;

  margin: 0 auto;
  padding: 1rem 0 0.5rem 0;

  @media (width: 768px) {
    padding: 0 !important;
  }
  @media (min-width: 767px) {
    padding: 1rem 0 1rem 0;
  }
}

.items {
  // display: flex;
  align-items: stretch;
  position: relative;
  width: 100% !important;
  height: 100%;
  z-index: 1;
  display: flex;
  &.center-mode {
    @media (min-width: 768px) {
      justify-content: center;
    }
  }
}

.item {
  padding: 0;
  // display: flex;
  flex-shrink: 0;
  align-items: stretch;
  width: 100% !important;

  .nfwrapper {
    padding: 0;
    position: relative;
    border-radius: 6px;
    .btn {
      position: absolute;
      bottom: 2rem;
    }
  }

  .newbadge {
    background: red !important;
    padding: 5px;
  }
}

.feedcard {
  // border: 1px solid #faf6f6;
  padding: 0.15rem;
  text-align: left !important;
}

.filterbtn {
  text-align: center;
  color: #0D0A15;
  border: 1px solid #0D0A15;
  border-radius: 4px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  justify-content: center;
}
.filterbtn:hover {
  text-align: center;
  color: #0D0A15;
  border: 1px solid #0D0A15;
  border-radius: 4px;
  cursor: pointer;
}

.list-unstyled {
  z-index: 9999;
  list-style: none;
  background: #ffffff;
  width: 100%;
  color: #000000;
  border: 1px solid #0D0A15;
  border-radius: 4px;
  overflow: hidden;
  position: absolute;
  padding: 0px 10px;
}

.lili {
  z-index: 9999;
  padding: 3px 0px;
  font-size: 13px;
  cursor: pointer;
  color: #0D0A15;
  text-align: left;

  @media screen and (max-width: 992px) {
    font-size: 10px;
  }
}
.technical {
  background: #e4e4e4;
}
.clinical {
  background: #ffffff;
}
.dateposted {
  color: #4b4b4b;
  font-size: 9px;
  color: #4b4b4b;

  @media screen and (max-width: 992px) {
    font-size: 8px;
  }
}
.contenttype {
  color: #000;
  padding: 2px 8px;
  font-size: 9px;

  @media screen and (max-width: 992px) {
    font-size: 8px;
  }
}

.heading {
  @media (min-width: 768px) {
    margin-top: 10px;
  }
}

.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
  padding: 0 !important;
}

.custom-line-limit {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: all 0.2s ease-in-out;
  max-height: 3rem;

  &:hover {
    overflow: visible;
    text-overflow: visible;
    -webkit-line-clamp: 100;
    line-clamp: 100;
    max-height: 10rem;
  }

  @media screen and (max-width: 992px) {
    overflow: visible;
    text-overflow: visible;
    -webkit-line-clamp: 100;
    line-clamp: 100;
  }
}

// adjust spacing between newsfeed items.
.feedcard {
  min-height: 72px;

  @media screen and (max-width: 992px) {
    min-height: 64px;
  }

  @media screen and (max-width: 768px) {
    min-height: 69px;
  }
}
</style>
